import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { styledSystemTheme, theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint, getDirection } from "../../../../../common-deprecated/themes/common";
import IconWrapper from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Preloader from "../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as Form from "../../common/styles/FormsAem";

export const Card = styled.a<SpaceProps>`
    display: block;
    position: relative;
    width: 100%;
    margin-top: ${theme.space[4] / 2}px;
    padding: ${theme.space[2]}px;
    border: 1px solid ${theme.colors.grey2};
    transition: color .24s;
    ${space}
    @media ${getBreakpoint("up", "md")} {
        padding-${getDirection("right")}: 72px;
    }
    &:first-child {
        margin-top: 0;
    }
    ${IconWrapper} {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        padding-top: 1px;
        padding-${getDirection("left")}: 2px; /* hacky fix align icon because bad viewbox on iconfont */
        line-height: 29px;
        text-align: center;
        color: ${theme.colors.primaryWhite};
        background: ${theme.colors.primaryBlack};
        border-radius: 50%;
        transition: transform .24s ease-out;
    }

    &:hover, &:active {
        color: #000;
        ${IconWrapper} {
          transform: translateX(${styledSystemTheme.isRTL ? "-" : ""}3px);
        }
    }
`;

export const Actions = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: ${theme.space[3]}px;

    ${IconWrapper} {
      margin-${getDirection("left")}: auto;
    }

    @media ${getBreakpoint("up", "md")} {
        position: absolute;
        top: 50%;
        ${getDirection("right")}: ${theme.space[3]}px;
        justify-content: flex-end;
        width: auto;
        margin-top: ${theme.space[1]}px;
        margin-top: -16px;
    }
`;

export const CardTitle = styled.div`
    font-family: ${theme.fonts.regular};
`;

export type VehicleLinkType = {
    isOpen?: boolean;
};

export const FindVehicleLink = styled.button<VehicleLinkType>`
    display: inline-flex;
    flex-direction: ${styledSystemTheme.isRTL ? "row-reverse" : "row"};
    ${IconWrapper} {
        position: relative;
        top: ${({ isOpen }) => (isOpen ? "0" : "-1px")};
        transform: rotate(${styledSystemTheme.isRTL ? "-" : ""}${({ isOpen }) => (isOpen ? "90deg" : "0")});
        transition: all 0.24s;
    }
`;

export const FindVehicleForm = styled.div`
    margin-top: ${theme.space[3]}px;

    ${Form.Error} {
        display: flex;
        gap: ${theme.space[1]}px;
    }
`;

export const FindVehicleBtnHolder = styled.div`
    margin-top: ${theme.space[3]}px;
    text-align: ${getDirection("right")};
`;

export const LoadingWrapper = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    margin-top: ${theme.space[2]}px;
    padding-${getDirection("left")}: 36px; /* 20px (width preloader) + 16px (spacing) */
    color: ${theme.colors.grey7};

    ${Preloader} {
        width: 20px;
    }
`;
